import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight, faCheck } from "@fortawesome/free-solid-svg-icons";
import image from "../../images/AxiomosLogo.png";
import "./About.css";

const PRINCIPLES = [
  "Business-first product strategy",
  "Secure and scalable engineering",
  "Industry-focused digital solutions",
  "Ethical, dependable delivery",
];

const ScrollLink = ({ to, children, ...props }) => {
  const handleClick = () => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  };

  return (
    <RouterLink to={to} onClick={handleClick} {...props}>
      {children}
    </RouterLink>
  );
};

function About({ id = "about" }) {
  return (
    <section id={id} className="about-section" aria-labelledby="about-title">
      <div className="about-section__decoration" aria-hidden="true" />

      <div className="about-section__container">
        <div className="about-section__content">
          <p className="about-section__eyebrow">
            <span aria-hidden="true" />
            About Axiomos
          </p>

          <h2 id="about-title" className="about-section__title">
            Technology built around the
            <span> realities of your business.</span>
          </h2>

          <p className="about-section__lead">
            Axiomos Technologies LLP is a custom software development and
            digital transformation company helping organizations turn complex
            operational challenges into clear, dependable digital products.
          </p>

          <p className="about-section__description">
            Our work spans web and mobile applications, cloud platforms,
            automation, data-driven systems, and industry-specific solutions. We
            combine product thinking with responsible engineering to create
            technology that improves efficiency today and remains ready for
            tomorrow.
          </p>

          <ul
            className="about-section__principles"
            aria-label="How Axiomos works"
          >
            {PRINCIPLES.map((principle) => (
              <li key={principle}>
                <span aria-hidden="true">
                  <FontAwesomeIcon icon={faCheck} />
                </span>
                {principle}
              </li>
            ))}
          </ul>

          <div className="about-section__actions">
            <ScrollLink className="about-section__button" to="/about">
              Learn about Axiomos
              <FontAwesomeIcon icon={faArrowRight} aria-hidden="true" />
            </ScrollLink>

            <ScrollLink className="about-section__text-link" to="/contact">
              Discuss your idea
            </ScrollLink>
          </div>
        </div>

        <div
          className="about-section__visual"
          aria-label="Axiomos brand statement"
        >
          <div className="about-section__visual-panel">
            <span className="about-section__visual-index" aria-hidden="true">
              AX / 01
            </span>

            <div className="about-section__brand-card">
              <img
                src={image}
                className="about-section__logo"
                alt="Axiomos Technologies LLP"
                loading="lazy"
                decoding="async"
              />
              <span aria-hidden="true" />
              <p>Custom software and digital transformation</p>
            </div>

            <div className="about-section__statement">
              <span>Our approach</span>
              <strong>Understand. Design. Engineer. Evolve.</strong>
            </div>
          </div>

          <div className="about-section__floating-note">
            <span aria-hidden="true">
              <FontAwesomeIcon icon={faCheck} />
            </span>
            <div>
              <strong>Purpose-led technology</strong>
              <small>Designed to create measurable business value</small>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
